<template>
  <div class="breadcrumb">
    <a class="breadcrumb-item" v-for="element in elements" v-link="{ path: element.link }" :class="{ active: element.active }">{{ element.name }}</a>
  </div>
</template>

<script>
  export default {
    props: {
      current: {
        type: String,
        default: ''
      },
      label: {
        type: Array,
        default: function () {
          return []
        }
      },
      links: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    data () {
      return {
        'elements': [],
        'mapping': [
          ['', 'Accueil'],
          ['contact/list', 'Gestion des participants'],
          ['project/list', 'Gestion des parcours'],
          ['entreprise', 'Entreprise'],
          ['add', 'Ajouter'],
          ['edit', 'Modifier'],
          ['administration', 'Administration']
        ]
      }
    },
    watch: {
      'current': function () {
        this.create()
      }
    },
    ready () {
      this.create()
    },
    methods: {
      create: function () {
        let that = this

        if (this.links.length > 0) {
          this.links.forEach(function (node) {
            that.elements.push({ 'link': node.link, name: node.label, active: false })
          })
        } else {
          let nodes = this.$route.path.split('/')
          if (this.$route.path === '/') { nodes.pop() }

          let currentLink = []

          let mapping = new Map(this.mapping)
          this.label.forEach(function (el) {
            if (Array.isArray(el) && el.length > 1) mapping.set(el[0], el[1])
          })

          this.elements = []

          nodes.forEach(function (el, index) {
            if (!Number.isNaN(Number.parseInt(el))) {
              that.elements.pop()
            }

            currentLink.push(el.toLowerCase())

            let link = currentLink.length > 1 ? currentLink.join('/') : '/'
            let active = ((nodes.length - 1) === index)

            if (mapping.has(el)) {
              that.elements.push({ 'link': link, name: mapping.get(el), active: active })
            } else {
              that.elements.push({ 'link': link, name: that.current, active: active })
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Breadcrumb.vue?4728a9bf